import type { StoreState } from '../../state-types';

/** Get next index card id */
export const getCardNextIndexCardId =
    (cardId: string) =>
    (state: StoreState): string | undefined => {
        const cardIds = state.survey.cardIds;
        const cardIndex = cardIds.findIndex((id) => id === cardId);
        const id = cardIds[cardIndex + 1];

        return id || undefined;
    };
